<template>
    <table class="text-center font-weight-bold">
        <tr class="grey lighten-3">
            <td class="reportBorders">Schnitt</td>
            <td class="reportBorders">FW</td>
            <td class="reportBorders">Abräumen</td>
            <td class="reportBorders">Gesamtkegel</td>
            <td colspan="3" class="reportBorders font-weight-bold text-decoration-underline">ENDERGEBNIS</td>
            <td class="reportBorders">Gesamtkegel</td>
            <td class="reportBorders">Abräumen</td>
            <td class="reportBorders">FW</td>
            <td class="reportBorders borderRight">Schnitt</td>
        </tr>
        <tr v-if="!isLeer">
        <!-- Schnitt -->
            <td class="leftCell">{{dataObject.heim.result.schnitt}}</td>
        <!-- Fehlwürfe -->
            <td class="leftCell">{{dataObject.heim.result.fw}}</td>
        <!-- Abräumen -->
            <td class="leftCell">{{dataObject.heim.result.ar}}</td>
        <!-- Kegel -->
            <td class="leftCell" rowspan="2" style="max-width: 100px">
                {{dataObject.heim.result.kegel}}
                <div class="caption" style="line-height: 1.2;">{{dataObject.getTeamRekordString('heim')}}</div>
            </td>
        <!-- GESAMTERGEBNIS -->
            <td class="leftCell">{{dataObject.heim.result.kegel - dataObject.gast.result.kegel}}</td>
            <td class="leftCell">:</td>
            <td class="leftCell">{{dataObject.gast.result.kegel - dataObject.heim.result.kegel}}</td>
        <!-- Kegel -->
            <td class="leftCell" style="max-width: 100px">
                {{dataObject.gast.result.kegel}}
                <div class="caption" style="line-height: 1.2;">{{dataObject.getTeamRekordString('gast')}}</div>
            </td>
        <!-- Abräumen -->
            <td class="leftCell">{{dataObject.gast.result.ar}}</td>
        <!-- Fehlwürfe -->
            <td class="leftCell">{{dataObject.gast.result.fw}}</td>
        <!-- Schnitt -->
            <td class="leftCell borderRight">{{dataObject.gast.result.schnitt}}</td>
        </tr>
        <tr v-else>
            <td class="leftCell"></td>
            <td class="leftCell"></td>
            <td class="leftCell"></td>
            <td class="leftCell" style="max-width: 100px"></td>
            <td class="leftCell result font-weight-bold" rowspan="2"></td>
            <td class="leftCell">:</td>
            <td class="leftCell result font-weight-bold" rowspan="2"></td>
            <td class="leftCell" style="max-width: 100px"></td>
            <td class="leftCell"></td>
            <td class="leftCell"></td>
            <td class="leftCell borderRight"></td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: "spiel-bericht-print-result-cup",
        props: ['dataObject', 'isLeer'],
    }
</script>

<style scoped>
    table {width: 100%; border-spacing: 0; table-layout: auto; font-size: 12px}
    .result {font-size: 16px}
    .leftCell {
        border-left: solid 1px grey;
        border-top: solid 1px grey;
        border-bottom: solid 1px grey;
        padding-bottom: 4px;
        padding-top: 4px;
    }
    .secondRowCell {
        border-left: solid 1px grey;
        border-bottom: solid 1px grey;
    }
    .secondRowCellBottom {
        border-bottom: solid 1px grey;
    }
    .reportBorders {
        border-left: solid 1px grey;
        border-top: solid 1px grey;
        padding-top: 4px;
        padding-bottom: 4px;
    }
    .borderRight {border-right: solid 1px grey; }
    /*tr { border-left: solid 1px grey; border-top: solid 1px grey}
    td {border-right: solid 1px grey; border-bottom: solid 1px grey}*/
</style>